/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetEmployeeAttendanceById200ResponseRecordsInner } from './GetEmployeeAttendanceById200ResponseRecordsInner';
import {
    GetEmployeeAttendanceById200ResponseRecordsInnerFromJSON,
    GetEmployeeAttendanceById200ResponseRecordsInnerFromJSONTyped,
    GetEmployeeAttendanceById200ResponseRecordsInnerToJSON,
    GetEmployeeAttendanceById200ResponseRecordsInnerToJSONTyped,
} from './GetEmployeeAttendanceById200ResponseRecordsInner';

/**
 * 
 * @export
 * @interface GetEmployeeAttendanceById200Response
 */
export interface GetEmployeeAttendanceById200Response {
    /**
     * 
     * @type {string}
     * @memberof GetEmployeeAttendanceById200Response
     */
    employeeName: string;
    /**
     * 
     * @type {Array<GetEmployeeAttendanceById200ResponseRecordsInner>}
     * @memberof GetEmployeeAttendanceById200Response
     */
    records: Array<GetEmployeeAttendanceById200ResponseRecordsInner>;
}

/**
 * Check if a given object implements the GetEmployeeAttendanceById200Response interface.
 */
export function instanceOfGetEmployeeAttendanceById200Response(value: object): value is GetEmployeeAttendanceById200Response {
    if (!('employeeName' in value) || value['employeeName'] === undefined) return false;
    if (!('records' in value) || value['records'] === undefined) return false;
    return true;
}

export function GetEmployeeAttendanceById200ResponseFromJSON(json: any): GetEmployeeAttendanceById200Response {
    return GetEmployeeAttendanceById200ResponseFromJSONTyped(json, false);
}

export function GetEmployeeAttendanceById200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetEmployeeAttendanceById200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeName': json['employeeName'],
        'records': ((json['records'] as Array<any>).map(GetEmployeeAttendanceById200ResponseRecordsInnerFromJSON)),
    };
}

export function GetEmployeeAttendanceById200ResponseToJSON(json: any): GetEmployeeAttendanceById200Response {
    return GetEmployeeAttendanceById200ResponseToJSONTyped(json, false);
}

export function GetEmployeeAttendanceById200ResponseToJSONTyped(value?: GetEmployeeAttendanceById200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeName': value['employeeName'],
        'records': ((value['records'] as Array<any>).map(GetEmployeeAttendanceById200ResponseRecordsInnerToJSON)),
    };
}

